const Play = ({ ...props }) => {
  return (
    <svg
      width="43"
      height="58"
      viewBox="0 0 43 58"
      // fill="none"

      {...props}
    >
      <path
        d="M0.5 0.730469L42.5 28.9942L0.5 57.2579V0.730469Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Play
